import AppForm from '../app-components/Form/AppForm';
import FormMixin from './formMixin';

Vue.component('app-payment-form-show', {
    mixins: [AppForm, FormMixin],
    methods:{
        
        async changeSplitPayment(event, value){
            const newValue = !value
            try {

                let resultData = await axios.post(this.action, {split_payment: newValue})
                console.log('resultData', resultData)
                this.form.split_payment = event.target.value =  newValue

              } catch (error) {
                this.form.split_payment = event.target.value =  !newValue
                console.log('error', error) 
                this.$notify({ type: 'warning', title: 'Peringatan!', text: error.response.data.message})
              }
        },
        async makePayment(paymentType, is_global){
            try {
                const _this4 = this
                /* 
                let result = await axios.post(this.urlPaymentFinance, {payment_type: paymentType})
                const { data: responseData } = result
                responseData.data.payment
                if (responseData.print_url) {
                    window.open(responseData.print_url);
                } */
                
                if (this.submiting) {
                    return false;
                }
                this.submiting = true;

                axios.post(_this4.urlPaymentFinance, {payment_type: paymentType, global: is_global})
                .then(function (result) {
                    
                    const { data: responseData } = result
                    
                    if (responseData.print_url) {
                        window.open(responseData.print_url);
                        setTimeout(() => {
                            _this4.submiting = false;
                        }, 2000);
                    }
    
                  }).catch(function (error) {
                    const { data: responseData } = error.response
                    console.log('responseData', responseData)

                    _this4.$notify({ type: 'error', title: 'Error !', text: responseData.message })
                    if (responseData.group_status=="on_progress") {
                        _this4.pollPaymentStatus(responseData.payment_id);
                    } else {
                        setTimeout(() => {
                            _this4.submiting = false;
                        }, 2000);
                        
                    }
                  });
                
              } catch (error) {
                _this4.$notify({ type: 'error', title: 'Error !', text: error.response.data.message})
              }
              return false
        },
        pollPaymentStatus(paymentId) {
            const _this4 = this
            const pollInterval = setInterval(async () => {
                try {
                    
                    const response = await axios.get(_this4.urlCheckPaymentGroup)
                    
                    if (response.data.status === 'completed') {
                        clearInterval(pollInterval)
                        setTimeout(() => {
                            _this4.submiting = false;
                        }, 5000);
                        window.open(response.data.print_url);
                    }
                } catch (error) {
                    console.log('pollPaymentStatus error:', error)
                    clearInterval(pollInterval)
                    _this4.submiting = false;
                    _this4.$notify({ type: 'error', title: 'Error !', text: 'Polling failed' })
                }
            }, 5000)
        },
        async farmerSlipGlobal(paymentType){
            const _this4 = this
            this.submiting = true;
            try {
                if (paymentType=='farmer' && _this4.urlFarmerSlipGlobal) {
                    window.open(_this4.urlFarmerSlipGlobal);
                }
                
                if (paymentType=='payment_group' && _this4.urlFarmerGroupSlipGlobal) {
                    window.open(_this4.urlFarmerGroupSlipGlobal);
                }
                
                setTimeout(() => {
                    _this4.submiting = false;
                }, 2000);
                return false
                
              } catch (error) {
                _this4.$notify({ type: 'error', title: 'Error !', text: error.message})
              }
              return false
        },
        
    },
    props: {
        selectedFarmerDriver: {
            type: Object,
            default: {}
        },
        selectedFactory: {
            type: Object,
            default: {}
        },
        selectedField: {
            type: Object,
            default: {}
        },
        selectedPriceFactory: {
            type: Object,
            default: {}
        },
        urlPaymentFinance: {
            type: String,
            default: ""
        },
        urlFarmerSlipGlobal: {
            type: String,
            default: ""
        },
        urlFarmerGroupSlipGlobal: {
            type: String,
            default: ""
        },
        urlCheckPaymentGroup: {
            type: String,
            default: ""
        },
        priceExtras: {
            type: Array,
            default: ()=>[]
        },
        activePaymentGroup: {
            type: Object,
            default: {}
        },
        indexY: {
            type: String,
            default: ""
        },
    },
    mounted: function () {  
        this.groupPayments = this.activePaymentGroup?.payments||[]
        this.activePaymentGroup.status_label
        if (this.activePaymentGroup.status_label=="on_progress") {
            this.submiting = false;
            
            this.pollPaymentStatus(this.data.id);
        }
    },
    computed: {
        hasSplit(){
            return this.form.split_payment==1
        },
    },
    data: function() {
        return {
            groupPayments:[]
        }
    }
    //   watch:{
    //     'form.split_payment': function(newVal, oldVal){
    //         // this.form.split_payment = oldVal
    //        console.log("New split_payment value: "+ newVal + ", Old value: " + oldVal);
    //     //    this.$refs.targetsplit.value = newVal
    //     //    this.$refs.targetsplit.value = this.form.split_payment= oldVal
    //     //    this.form.split_payment = event.target.value =  value
    //     },
    //  }

});